import LeaseConditionsCard from "../UI/LeaseConditionsCard";
// @ts-expect-error pure js
import TenantLeaseForm from "./PartForms/TenantLeaseForm";
// @ts-expect-error pure js
import PartForm from "../UI/PartForm";
import {
  TENANT_INITIAL_VALUE,
  tenantLeaseFormSchema,
  // @ts-expect-error pure js
} from "../../models/tenant_old.js";
// @ts-expect-error pure js
import { sanitizeValues, toInitialValuesFromSchema } from "../../models/utils";
// @ts-expect-error pure js
import { useModal } from "../../hooks/use-modal.jsx";
// @ts-expect-error pure js
import useTenants from "../../hooks/use-tenants";
// @ts-expect-error pure js
import useLeaseTemplates from "../../hooks/use-lease-templates";
import { allowsChargesForfait } from "../../utils/constants/tenants";
// @ts-expect-error pure js
import { useConfirm } from "../../hooks/use-confirm.jsx";
// @ts-expect-error pure js
import { changeTenantProrata } from "../../utils/tenants";
import type { Tenant } from "../../models/tenant";
import type { LeaseTemplate } from "../../models/leaseTemplate";
import { formatTypeIndice, INDEX_TYPES } from "../../models/property";

interface TenantLeaseCardProps {
  tenant: Tenant;
  allowEdit?: boolean;
  propertyType?: string;
  propertyTypeIndice?: string | null;
}

/** Choix du formulaire : « IRL » quel que soit la région, sinon l'indice national du bail ou du bien. */
function initialIndexType(tenant: Tenant, propertyTypeIndice?: string | null) {
  const current = formatTypeIndice(tenant.type_irl || propertyTypeIndice);
  return INDEX_TYPES.includes(current) ? current : "IRL";
}

export default function TenantLeaseCard({
  tenant,
  allowEdit,
  propertyType,
  propertyTypeIndice,
}: TenantLeaseCardProps) {
  const [
    LeaseTenantFormModal,
    closeLeaseTenantFormModal,
    openLeaseTenantFormModal,
  ] = useModal();
  const [Confirm, openConfirm] = useConfirm();

  const { updateTenant, updateProrataTenant } = useTenants();
  const { leaseTemplatesById } = useLeaseTemplates({ withById: true }) as {
    leaseTemplatesById: Record<number, LeaseTemplate>;
  };
  // Sans modèle de bail (bail importé), la règle se fonde sur le seul type de bail.
  const leaseTemplate = tenant.id_lease_template
    ? leaseTemplatesById[tenant.id_lease_template]
    : undefined;
  const allowChargesForfait = allowsChargesForfait(
    leaseTemplate ?? { type: tenant.lease_type },
  );

  return (
    <>
      <Confirm
        onAnswer={async (ok: boolean) => {
          if (ok) {
            try {
              await updateProrataTenant(tenant.id);
            } catch (error) {
              console.error(error);
            }
          }
        }}
        size={"small"}
      >
        <p>
          Nous avons détecté que vous avez changé la date de fin du contrat de
          bail. Souhaitez-vous mettre à jour le prorata de loyer pour le dernier
          mois dans l'historique des paiements ?
        </p>
      </Confirm>
      <LeaseTenantFormModal size={"big"}>
        <PartForm
          partForm={
            <TenantLeaseForm
              leaseType={tenant.lease_type}
              propertyType={propertyType}
              allowChargesForfait={allowChargesForfait}
            />
          }
          initialValues={{
            ...toInitialValuesFromSchema(
              tenantLeaseFormSchema,
              tenant,
              TENANT_INITIAL_VALUE,
            ),
            is_type_quittance: String(tenant.is_type_quittance ?? true),
            type_irl: initialIndexType(tenant, propertyTypeIndice),
          }}
          submitHandler={async (values: Record<string, unknown>) => {
            await updateTenant(tenant.id, sanitizeValues(values));
            if (changeTenantProrata(tenant, values)) {
              openConfirm();
            }
          }}
          closeModal={closeLeaseTenantFormModal}
          validationSchema={tenantLeaseFormSchema}
        />
      </LeaseTenantFormModal>

      <LeaseConditionsCard
        leaseConditions={{
          ...tenant,
          // tenant.loyer_hc inclut le complément ; la card attend le loyer de base
          // et affiche le complément séparément.
          loyer_hc:
            tenant.loyer_hc === undefined
              ? undefined
              : Math.round(
                  (tenant.loyer_hc - (tenant.complement_loyer ?? 0)) * 100,
                ) / 100,
        }}
        onEdit={allowEdit ? openLeaseTenantFormModal : undefined}
      />
    </>
  );
}
